import {makeStyles} from '@material-ui/core';
import {DRAWER_WIDTH, DRAWER_WIDTH_CLOSED, HEADER_HEIGHT} from './components/AppHeader/styles';

const drawerWidth = 240;

export const useStyles = makeStyles(theme => ({
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    marginLeft: '60px',
    paddingTop: '1rem',
    backgroundColor: 'rgba(50,50,50,0.05)',
    minHeight: '100vh',
  },
  contentShift: {
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    marginLeft: drawerWidth,
    paddingLeft: '45px',
  },
  userContent: {
    flexGrow: 1,
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    top: 0,
    marginLeft: DRAWER_WIDTH_CLOSED,
    paddingLeft: '0rem',
    paddingTop: HEADER_HEIGHT,
    backgroundColor: 'rgba(50,50,50,0.05)',
    minHeight: '100vh',
  },
  userContentShift: {
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    marginLeft: DRAWER_WIDTH,
    paddingLeft: '20px',
    paddingRight: '20px',
  },
}));
